import React from "react";
import "./circular-progress-char.css";

const ProgressCircle = ({ percentage }) => {
  return (
    <div className="circle-bar-container">
      <div className="circle-bar-container-inner">
        <div className="circle">
          <div className="circle2">
            <div
              className="water-fill"
              style={{
                height: `${percentage}%`,
              }}></div>
            <div className="percentage-text">{percentage}%</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressCircle;
